<template>
  <div class="item password">
    <div class="title">{{titleName}}</div>
    <a-input class="input-item pwdinput" :type="isShowPwd ? 'text' : 'password'" name="password" v-model="passwordValue" :placeholder="placeholder" autocomplete="off"/>
    <img class="pwd-img" :src="pwdImg" @click="handleShowPwd">
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "请输入密码"
    },
    titleName: {
      type: String,
      default: "密码"
    }
  },
  data() {
    return {
      isShowPwd: false, // 是否显示密码
      pwdImg: require("../../assets/imgs/ico2.png"),
      passwordValue: "",
      encodeStr: "",
    };
  },
  methods: {
    getPwdValue() {
      return this.encode();
    },
    /**
     * 加密
     */
    encode() {
      var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      this.encodeStr= this._utf8_encode(this.passwordValue);
      while (i < this.encodeStr.length) {
          chr1 = this.encodeStr.charCodeAt(i++);
          chr2 = this.encodeStr.charCodeAt(i++);
          chr3 = this.encodeStr.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;
          if (isNaN(chr2)) {
              enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
              enc4 = 64;
          }
          output = output +
              _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
              _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
      }

      return output;
    },
    _utf8_encode(string) {
      string = string.replace(/\r\n/g, "\n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
              utftext += String.fromCharCode(c);
          } else if ((c > 127) && (c < 2048)) {
              utftext += String.fromCharCode((c >> 6) | 192);
              utftext += String.fromCharCode((c & 63) | 128);
          } else {
              utftext += String.fromCharCode((c >> 12) | 224);
              utftext += String.fromCharCode(((c >> 6) & 63) | 128);
              utftext += String.fromCharCode((c & 63) | 128);
          }
  
      }

      return utftext;
    },
    /**
     * 是否显示密码
     */
    handleShowPwd() {
      this.isShowPwd = !this.isShowPwd;
      if (this.isShowPwd) {
        this.pwdImg = require("../../assets/imgs/ico5.png");
      } else {
        this.pwdImg = require("../../assets/imgs/ico2.png");
      }
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
}
.input-item {
  border: 1px solid #d7d7d7;
  background: #f7f7f7;
  padding: 0 15px;
  line-height: 48px;
  height: 50px;
  overflow: hidden;
  position: relative;
}
.title {
  width: 80px;
  max-width: 80px;
  min-width: 80px;
  line-height: 52px;
  display: block;
  float: left;
  font-size: 16px;
  text-align: right;
  padding-right: 4px;
}
.password {
  position: relative;
}
.pwdinput {
  padding-right: 40px;
}
.pwd-img {
  position: absolute;
  width: 22px;
  height: 19px;
  right: 15px;
  top:15px;
  cursor: pointer;
}
@media screen and (max-width: 1024px) {
  .input-item {
    height: 40px;
  }
  .title {
    font-size: 14px;
    max-width: 60px;
    min-width: 60px;
    line-height: 40px;
    text-align: right;
    padding-right: 3px;
  }
}
</style>